import { baseApi } from '@/lib/rtkQuery/baseApi';

import {
	RegisterNewPatientRequestObject,
	RegisterNewPatientResponseObject,
	VerifyNewPatientRequestObject,
	VerifyNewPatientResponseObject,
	UpdateNewPatientRequestObject,
	UpdateNewPatientResponseObject,
	SubmitNewPatientRequestObject,
	ValidateEmailAddressRequestObject,
	ValidateEmailAddressResponseObject,
} from '../types';

export const patientListApi = baseApi
	.enhanceEndpoints({
		addTagTypes: [],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			registerNewPatient: build.mutation<
				RegisterNewPatientResponseObject,
				RegisterNewPatientRequestObject
			>({
				query: ({ values }) => {
					return {
						url: 'v1/patient-registration/',
						method: 'POST',
						body: values,
					};
				},
			}),
			verifyNewPatient: build.mutation<
				VerifyNewPatientResponseObject,
				VerifyNewPatientRequestObject
			>({
				query: ({ values, patient_id }) => {
					return {
						url: `v1/patient-registration/${patient_id}/verify/`,
						method: 'POST',
						body: values,
					};
				},
			}),
			updateNewPatient: build.mutation<
				UpdateNewPatientResponseObject,
				UpdateNewPatientRequestObject
			>({
				query: ({ patient_id, values }) => {
					return {
						url: `v1/patient-registration/${patient_id}/`,
						method: 'PATCH',
						body: values,
					};
				},
			}),
			submitNewPatient: build.mutation<void, SubmitNewPatientRequestObject>({
				query: ({ patient_id }) => {
					return {
						url: `v1/patient-registration/${patient_id}/submit/`,
						method: 'POST',
					};
				},
			}),
			resendVerfication: build.mutation<void, SubmitNewPatientRequestObject>({
				query: ({ patient_id }) => {
					return {
						url: `v1/patient-registration/${patient_id}/resend-verification/`,
						method: 'POST',
					};
				},
			}),
			getHciByShortName: build.query({
				query: (hci_shortname) => {
					return {
						url: `v1/patient-registration/hcis/${hci_shortname}/`,
						method: 'GET',
					};
				},
			}),
			validateEmailAddress: build.mutation<
				ValidateEmailAddressResponseObject,
				ValidateEmailAddressRequestObject
			>({
				query: (email) => {
					return {
						url: 'v1/patient-registration/validate-email/',
						method: 'POST',
						body: email,
					};
				},
			}),
		}),
	});

export const {
	useRegisterNewPatientMutation,
	useVerifyNewPatientMutation,
	useUpdateNewPatientMutation,
	useSubmitNewPatientMutation,
	useResendVerficationMutation,
	useValidateEmailAddressMutation,
	useGetHciByShortNameQuery,
} = patientListApi;
